module.exports = __webpack_public_path__ + "static/iphone-6-portrait-2469146e94c708f63d90d187a0494950.png";